module.exports = __webpack_public_path__ + "img/feature-10.cf3483a9.jpg";